import React from "react";

import ExternalButton, {
  type ExternalButtonProps,
} from "@stadium/ui/src/components/button/external-button";
import {
  StyledLink,
  StyledButton,
  type StyledLinkProps,
  type StyledButtonProps,
} from "@stadium/ui/src/components/button/styled-button";

import styles from "./main.module.scss";

const Button = (props: StyledButtonProps) => (
  <StyledButton displayChildren styles={styles} disableOnLoad {...props} />
);

export const LinkButton = (props: StyledLinkProps) => (
  <StyledLink displayChildren disableOnLoad styles={styles} {...props} />
);

export const ExternalLinkButton = (props: ExternalButtonProps) => (
  <ExternalButton styles={styles} {...props} />
);

export default Button;
